module.exports = __webpack_public_path__ + "static/media/Resume icon.ec92d669.png";